import { liteClient as algoliasearch } from "algoliasearch/lite";
import { computed } from "vue";
import { globals } from "@/core/globals";
import { reportAlgolia429 } from "@/core/utilities/application-insights/application-insights";
import { addSearchAnalyticsTags } from "@/shared/thorlabs/search/utils/search-analytics-tags";

//This one is for autocomplete
export const searchClient = computed(() => {
  const client = algoliasearch(globals.algoliaConfig.applicationId ?? "", globals.algoliaConfig.searchApiKey);
  const originalSearch = client.search.bind(client);
  client.search = (async (...args: Parameters<typeof originalSearch>) => {
    try {
      const [originalParams, requestOptions] = args;
      const params = addSearchAnalyticsTags(originalParams, "autocomplete");
      // The autocomplete preset uses the legacy array form; support both call shapes.
      const requests = Array.isArray(params) ? params : params.requests;
      // Sources sharing the same query (e.g. "products" + "productsAdditional") would otherwise bill it twice.
      const keys = requests.map((request) => JSON.stringify(request));
      const uniqueKeys = [...new Set(keys)];
      if (uniqueKeys.length === keys.length) {
        return await originalSearch(params, requestOptions);
      }
      const uniqueRequests = uniqueKeys.map((key) => requests[keys.indexOf(key)]);
      const dedupedParams = Array.isArray(params) ? uniqueRequests : { ...params, requests: uniqueRequests };
      const response = await originalSearch(dedupedParams as typeof params, requestOptions);
      return { ...response, results: keys.map((key) => response.results[uniqueKeys.indexOf(key)]) };
    } catch (error) {
      reportAlgolia429(error, "autocomplete");
      throw error;
    }
  }) as typeof client.search;
  return client;
});
